<template>
    <!-- <span v-if="svgContent" v-html="svgContent" :style="{ height: size + 'px', width: size + 'px' }" /> -->
    <section
        v-if="svgContent"
        v-html="svgContent"
        :style="{ height: size + 'px', width: size + 'px' }"
        :class="{ 'rotate-svg': isRotate }"></section>
</template>

<script>
import { svgService } from '../../services/svg.service'

export default {
    props: {
        name: String,
        color: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: '',
        },
        isRotate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            svgContent: '',
        }
    },
    mounted() {
        this.loadSvg()
    },
    watch: {
        color(newColor, oldColor) {
            if (newColor !== oldColor) {
                this.loadSvg()
            }
        },
        size(newSize, oldSize) {
            if (newSize !== oldSize) {
                this.loadSvg()
            }
        },
        name(newName, oldName) {
            if (newName !== oldName) {
                this.loadSvg()
            }
        },
    },
    methods: {
        loadSvg() {
            this.svgContent = svgService.getSvg(this.name, this.color, this.size)
            if (!this.svgContent) {
                console.error(`SVG with name '${this.name}' not found`)
            }
        },
    },
}
</script>
<style lang="scss">
.rotate-svg {
    svg {
        transform: rotate(180deg);
    }
}
</style>
